import { Button, Form, Input, Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import { label } from "../../../framework";
import * as ewcms from "../EWCMS/styleMaster";
import { connect } from "react-redux";
import useCountdown from "../../hooks/useCountdown";
import { dataWrapper } from "../../../redux/actions";
import maskEmail from "../../../utility/maskEmail";
import { errorMsg, formItemLayout } from "../../../const/constant";

const defaultBtnStyle = ewcms.defaultBtnStyle;
const polyuRed = ewcms.polyuRed;
const defaultTimerSec = 20;

function OtpModal(props) {
  const {
    dataFetch,
    setshowModal,
    setOtpInfo,
    email,
    title,
    showModal,
    device,
  } = props;
  const [hash, setHash] = useState(null);
  const [form] = Form.useForm();
  const { timer, startTimer } = useCountdown();

  const secondsToTime = (secs: number) => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  };
  const pad2 = (n: number) => {
    return n < 10 ? "0" + n : n;
  };

  const sendOtp = useCallback(async () => {
    startTimer(defaultTimerSec);
    //Await response for emailAddress
    if (process.env.REACT_APP_SKIP_OTP === "Y") {
      return;
    }
    const otpRes = await dataFetch("sendOTP", { email }, "POST");
    if (otpRes?.value?.hash) {
      setHash(otpRes.value.hash);
    } else {
      errorMsg("Internal Server Error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, dataFetch]);

  const verifyOtp = async () => {
    if (process.env.REACT_APP_SKIP_OTP === "Y") {
      setshowModal(false);
      setOtpInfo({ otpLogin: true });
      return;
    }
    const response = await dataFetch(
      "verifyOTP",
      { email, hash: hash, otp: form.getFieldValue("otp") },
      "POST"
    );
    if (response?.result === "0") {
      setshowModal(false);
      setOtpInfo({ otpLogin: true });
    } else {
      errorMsg("Incorrect OTP message, please retry");
      setOtpInfo({ otpLogin: false });
    }
  };

  //Send Email to New Login User (new when modal is opened and form is new)
  useEffect(() => {
    if (showModal && email !== "") {
      sendOtp();
    }
  }, [showModal, email, sendOtp]);

  return (
    <Modal
      title={title}
      open={showModal}
      onOk={() => setshowModal(false)}
      onCancel={() => setshowModal(false)}
      footer={null}
    >
      <Form
        name="basic"
        {...formItemLayout[device.size]}
        layout={device.size === "desktop" ? "horizontal" : "vertical"}
        initialValues={{ remember: true }}
        autoComplete="off"
        form={form}
        onFinish={verifyOtp}
      >
        <div style={{ textAlign: "left", paddingLeft: 10, paddingBottom: 15 }}>
          {label("LBOT044")}
          <strong>{maskEmail(email)}</strong>
        </div>
        <Form.Item
          label={label("LBOT039")}
          key="otp"
          required={true}
          name={"otp"}
          rules={[
            { required: true, message: label("EC0005").replace("{%1}", "OTP") },
            {
              len: 6,
              message: label("EC0014")
                .replace("{%1}", "6")
                .replace("{%2}", "Email"),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <div
            className="cust-spacebetween"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          >
            {timer > 0 ? (
              <div>
                {label("LBOT045")}
                <strong style={{ color: polyuRed }}>
                  {pad2(secondsToTime(timer).m)}:{pad2(secondsToTime(timer).s)}
                </strong>
              </div>
            ) : (
              <Button
                className={defaultBtnStyle + " cust-button-height"}
                type="primary"
                onClick={sendOtp}
              >
                {label("LBOT036")}
              </Button>
            )}
            <Button
              className={defaultBtnStyle + " cust-button-height"}
              type="primary"
              htmlType="submit"
            >
              {label("LBOT037")}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    csrf: state.action.csrf,
    device: state.session.device,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dataFetch: (apiPath, data, method) => {
    return dispatch(dataWrapper(apiPath, data, method));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OtpModal);
